import React, { Component } from "react";
import { connect } from "react-redux";
import SponsorCta from "./SponsorCta";
import ChildBirthDate from "./ChildBirthDate";
import ChildDescriptors from "./ChildDescriptors";
import { childImage } from "../../utils/helpers.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { isInteractiveKeyCode } from "../../utils/helpers";

class SpecialCircumstance extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <p>{this.props.text}</p>;
  }
}
class ChildTile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      divStyle: {
        gridRowEnd: "span 15",
      },
      didReceiveStyle: false,
      ctaClass: "child-learn-more",
        };
  }

  handleKeyUp(e) {
    if(isInteractiveKeyCode(e)) {
      this.props.changeView ?
      this.props.changeView(e, this.props.identifier, this.props.descriptorIndex) :
      undefined;
    }
  }

  setTileRowSpan() {
    const tile = this.childTileContent;
    const rowSpan = Math.ceil(
      (tile.getBoundingClientRect().height + this.props.gridVars.rowGap) / this.props.gridVars.rowSpanRatio
    );
    const tileHeight = Math.ceil(tile.getBoundingClientRect().height);
    let divStyle = {
      gridRowEnd: "span " + rowSpan,
      display: "flex",
    };
    this.setState({ divStyle, didReceiveStyle: true });
  }

  componentDidUpdate() {
    if (this.props.status == "COMPLETE" && this.state.didReceiveStyle === false) {
      this.setTileRowSpan();
      this.props.childDetail ? this.setState({ ctaClass: "sponsor-button" }) : null;
    }
  }

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  }

  

  render() {
    if (this.props.status == "COMPLETE") {
      let daysWaiting = "";
      if (this.props.daysAwaitingSponsorshipCount > 364) {
        daysWaiting = "over 1\xa0year";
      } else if(this.props.daysAwaitingSponsorshipCount >= 60 ) {
        daysWaiting = Math.floor( this.props.daysAwaitingSponsorshipCount / 30 ) + "\xa0months";
      } else {
        daysWaiting = this.props.daysAwaitingSponsorshipCount + "\xa0days";
      }

      const isVowelSoundAge = (age) => ["8","11","18"].includes(""+age);

      let ageText = "";
      if (this.props.age === 0) {
        ageText = "baby";
      } else {
        ageText = this.props.age + '-year-old';
      }

      const birthdateData = this.formatDate(this.props.birthdate);
      const orphan = this.props.orphanFlag === true 
        ? <SpecialCircumstance type="orphan" text="I am an orphan" tooltip="" /> 
        : "";

      return (
        <div
          className={`child-tile child-index-${this.props.id} ${this.props.classList}`}
          style={this.state.divStyle || "undefined"}
        >
          <div className="child-tile-content" ref={(el) => (this.childTileContent = el)}>
            <div className="child-header">
              <div
                className="child-photo zoom-hover__outer child-photo-link"
                onClick={(e) => (this.props.changeView ? this.props.changeView(e, this.props.identifier, this.props.descriptorIndex) : undefined)}
                onKeyUp={(e) => this.handleKeyUp(e)}
                tabIndex="0"
              >
                <img
                  className="zoom-hover__inner child-photo-thumb"
                  src={childImage(this.props, this.props.childDetail)}
                  alt={`Photo of ${this.props.givenName}`}
                />
              </div>
            </div>
            <div className="child-info">
              <div
                className="child-name-link"
                onClick={(e) => (this.props.changeView ? this.props.changeView(e, this.props.identifier, this.props.descriptorIndex) : undefined)}
                onKeyUp={(e) => this.handleKeyUp(e)}
                tabIndex="0"
              >
                <div className="child-name epsilon">{this.props.givenName}</div>
              </div>
              <div>
              <p className="child-info__text">
            <span data-child-age={this.props.age} className="child-age">
              {isVowelSoundAge(this.props.age) ? "an" : "a"} <span className="child-age-number">{ageText}</span>
            </span>{" "}
            <span className="child-gender">{this.props.gender === "Male" ? "boy" : "girl"}</span> from{" "}
            <span className="child-country" data-iso-code={this.props.countryCode}>
               {this.props.countryName} <ChildDescriptors descriptorIndex={this.props.descriptorIndex} descriptorsReceived={this.props.descriptorsReceived} />
            </span>
          </p>
                <p className="child-birthday centi">
                  <img src="https://wvusstatic.com/2018/sponsorship-app/cupcake.svg" alt=""/>
                  <span className="child-birth-date" data-child-birth-date={birthdateData}>
                    <ChildBirthDate dateVal={this.props.birthdate} />
                  </span>
                </p> 
                {orphan}
                <p className="child-days-waiting centi">
                  <span className="clock">
                    <FontAwesomeIcon icon={faClock} />
                  </span>
                  <span className="child-days-waiting-text">
                    waiting <span className="child-days-waiting-number">{daysWaiting}</span>
                  </span>
                </p>
              </div>
            </div>
            <SponsorCta
              fireAddToCart={this.props.fireAddToCart}
              handleHistory={this.props.addHistory}
              urlLink={this.props.urlLink}
              classList={["cta-link", this.state.ctaClass]}
              sponsorshipTileCtaText={this.props.sponsorshipTileCtaText}
              changeView={this.props.changeView}
              identifier={this.props.identifier}
              descriptorIndex={this.props.descriptorIndex}
            />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(mapStateToProps)(ChildTile);
